/* Abrigo Diciembre a la Colombiana · Abrigos de Mi Tierra
   Packs (1, 2 o 3 abrigos), galería con puntos, tarjetas de precios, compra con Releasit
   y CTA fijo. Sin personalización: el botón de compra está activo desde el inicio.
   Sin librerías. Todo vive dentro de #hcpa. */
(function () {
  "use strict";

  var CONFIG = {
    // Deben ser iguales a la oferta por cantidad de Releasit.
    packs: [
      { unidades: 1, precio: 129900, titulo: "1 abrigo", sub: "Para ti" },
      { unidades: 2, precio: 199900, titulo: "2 abrigos", cinta: "Para regalar", nota: "Uno para ti y otro para regalar" },
      { unidades: 3, precio: 269900, titulo: "3 abrigos", cinta: "Mejor precio", nota: "Para compartir en familia" }
    ]
  };

  var raiz = document.getElementById("hcpa");
  if (!raiz) return;
  var $ = function (id) { return document.getElementById(id); };

  // En Shopify la sección imprime las variantes reales (id y precio) en #hcpa-datos.
  // Sin ese bloque (demo local) se usan los precios de CONFIG y el botón no compra.
  var tienda = null;
  try { tienda = JSON.parse($("hcpa-datos").textContent); } catch (e) { tienda = null; }
  // Dos formas de montar el producto en Shopify:
  //  · 3 variantes (1, 2 y 3 unidades): cada pack usa su variante y su precio, cantidad 1.
  //  · 1 variante + oferta por cantidad de Releasit: todos usan la misma variante con
  //    cantidad 1, 2 o 3; el descuento lo pone Releasit y los precios de CONFIG deben coincidir.
  if (tienda && tienda.variantes && tienda.variantes.length >= CONFIG.packs.length) {
    CONFIG.packs.forEach(function (p, i) {
      p.variante = tienda.variantes[i].id;
      p.precio = tienda.variantes[i].precio;
      p.disponible = tienda.variantes[i].disponible;
      p.cantidadForm = 1;
    });
  } else if (tienda && tienda.variantes && tienda.variantes.length === 1) {
    CONFIG.packs.forEach(function (p) {
      p.variante = tienda.variantes[0].id;
      p.disponible = tienda.variantes[0].disponible;
      p.cantidadForm = p.unidades;
    });
  } else {
    tienda = null;
  }

  var pesos = function (n) { return "$" + n.toLocaleString("es-CO"); };
  var unitario = CONFIG.packs[0].precio;
  var ahorro = function (p) { return unitario * p.unidades - p.precio; };
  var cadaUno = function (p) { return pesos(Math.round(p.precio / p.unidades)) + " c/u"; };
  var suave = function () { return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"; };

  var estado = { pack: 0 };

  /* ---------- Packs ---------- */
  function pintarPacks() {
    var lista = $("hcpa-packs");
    CONFIG.packs.forEach(function (p, i) {
      var a = ahorro(p);
      var label = document.createElement("label");
      label.className = "hcpa-pack";
      label.innerHTML =
        '<input type="radio" name="hcpa-pack" value="' + i + '"' + (i === estado.pack ? " checked" : "") + ">" +
        (p.cinta ? '<span class="hcpa-pack__cinta">' + p.cinta + "</span>" : "") +
        '<span class="hcpa-pack__radio" aria-hidden="true"></span>' +
        '<span><span class="hcpa-pack__titulo">' + p.titulo + "</span>" +
          (a > 0
            ? '<span class="hcpa-pack__sub">' + cadaUno(p) + '</span><span class="hcpa-pack__ahorro">Ahorras ' + pesos(a) + "</span>"
            : '<span class="hcpa-pack__sub">' + p.sub + "</span>") +
        "</span>" +
        '<span class="hcpa-pack__precio">' + pesos(p.precio) +
          (a > 0 ? '<span class="hcpa-pack__antes"><span class="hcpa-sr">Antes </span>' + pesos(unitario * p.unidades) + "</span>" : "") +
        "</span>";
      label.querySelector("input").addEventListener("change", function () { elegirPack(i); });
      lista.appendChild(label);
    });
  }

  /* ---------- Tarjetas de precios ---------- */
  function pintarPlanes() {
    var lista = $("hcpa-planes");
    CONFIG.packs.forEach(function (p, i) {
      var a = ahorro(p);
      var plan = document.createElement("article");
      plan.className = "hcpa-plan" + (i === CONFIG.packs.length - 1 ? " hcpa-plan--destacado" : "");
      plan.innerHTML =
        (p.cinta ? '<span class="hcpa-plan__cinta">' + p.cinta + "</span>" : "") +
        '<p class="hcpa-plan__titulo">' + p.titulo + "</p>" +
        '<p class="hcpa-plan__precio">' + pesos(p.precio) + "</p>" +
        '<p class="hcpa-plan__nota">' + (a > 0 ? cadaUno(p) + " · " + p.nota : p.sub) + "</p>" +
        (a > 0 ? '<p class="hcpa-plan__ahorro">Ahorras ' + pesos(a) + "</p>" : "") +
        '<button type="button" class="hcpa-cta"><span class="hcpa-cta__l1">Elegir ' + p.titulo + "</span></button>";
      plan.querySelector("button").addEventListener("click", function () {
        $("hcpa-packs").querySelectorAll("input")[i].checked = true;
        elegirPack(i);
        $("hcpa-zona-compra").scrollIntoView({ block: "center", behavior: suave() });
      });
      lista.appendChild(plan);
    });
  }

  function elegirPack(i) {
    estado.pack = i;
    refrescar();
  }

  function refrescar() {
    var pack = CONFIG.packs[estado.pack];
    var a = ahorro(pack);
    $("hcpa-precio-etiqueta").textContent = "Precio de " + pack.titulo;
    $("hcpa-precio-actual").textContent = pesos(pack.precio);
    $("hcpa-precio-ahorro").hidden = a <= 0;
    $("hcpa-precio-ahorro").textContent = "Ahorras " + pesos(a);
    $("hcpa-comprar-txt").textContent = "Comprar ahora · " + pesos(pack.precio);
    $("hcpa-sticky-l1").textContent = "Comprar ahora · " + pesos(pack.precio);
    $("hcpa-prueba").hidden = true;
    $("hcpa-comprar-error").textContent = "";
    sincronizarFormulario();
  }

  /* ---------- Formulario que lee Releasit ---------- */
  // Releasit toma la variante y la cantidad del formulario que contiene su botón.
  function sincronizarFormulario() {
    var pack = CONFIG.packs[estado.pack];
    $("hcpa-variante").value = pack.variante || "";
    $("hcpa-form-compra").querySelector('[name="quantity"]').value = pack.cantidadForm || 1;
  }

  // Releasit crea su botón al lado del gancho que está dentro del formulario de compra.
  // Si Releasit no carga, queda el botón propio que va al checkout de Shopify.
  function conectarReleasit(intentos) {
    window._COD_FORM_PRODUCT_PAGE_ADD_MODE_OVERWRITE = "add";
    var boton = $("hcpa-rsi").querySelector("._rsi-buy-now-button");
    if (!boton) {
      if (intentos > 0) setTimeout(function () { conectarReleasit(intentos - 1); }, 300);
      return;
    }
    $("hcpa-rsi").hidden = false;
    $("hcpa-comprar").hidden = true;
    raiz.classList.add("con-releasit");
  }

  // Releasit recuerda la oferta elegida la vez anterior: si el cliente abre su formulario con
  // un pack, lo cierra y cambia de pack, a veces se queda con la cantidad vieja. Cada vez que
  // (re)dibuja su formulario, se elige ahí la oferta que tiene la cantidad del pack de la landing.
  function ofertaEnReleasit() {
    var modal = document.getElementById("_rsi-cod-form-modal");
    if (!modal || !tienda) return;
    var ofertas = (window._RSI_COD_FORM_QUANTIY_OFFERS || []).filter(function (o) {
      return o.isActive && (o.pIds || []).indexOf(String(tienda.productoId)) >= 0;
    })[0];
    if (!ofertas) return;
    var unidades = CONFIG.packs[estado.pack].unidades;
    var oferta = ofertas.offers.filter(function (x) { return x.qty === unidades; })[0];
    if (!oferta) return;
    var opcion = modal.querySelector('._rsi-quantity-offers-offer-container[data-offer-pos="' + oferta.pos + '"]');
    if (!opcion || opcion.classList.contains("_rsi-quantity-offers-selected")) return;
    var clic = opcion.querySelector("._rsi-quantity-offers-offer");
    if (clic) clic.dispatchEvent(new MouseEvent("click", { bubbles: true }));
  }
  if (tienda && "MutationObserver" in window) {
    new MutationObserver(ofertaEnReleasit).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Comprar (demo / respaldo sin Releasit) ---------- */
  $("hcpa-comprar").addEventListener("click", function () {
    var pack = CONFIG.packs[estado.pack];
    if (tienda) { comprarEnShopify(pack); return; }
    var datos = [["Cantidad", pack.titulo], ["Total", pesos(pack.precio) + " · envío gratis"], ["Pago", "Contra entrega"]];
    var dl = $("hcpa-prueba-datos");
    dl.textContent = "";
    datos.forEach(function (d) {
      var dt = document.createElement("dt"); dt.textContent = d[0];
      var dd = document.createElement("dd"); dd.textContent = d[1];
      dl.appendChild(dt); dl.appendChild(dd);
    });
    $("hcpa-prueba").hidden = false;
    $("hcpa-prueba").scrollIntoView({ block: "nearest", behavior: suave() });
  });

  /* ---------- Compra real en Shopify (respaldo) ---------- */
  // Antes de agregar se quita este abrigo si ya estaba en el carrito, para no duplicarlo;
  // los demás productos no se tocan.
  function pedir(url, cuerpo) {
    return fetch(url, {
      method: cuerpo ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: cuerpo ? JSON.stringify(cuerpo) : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
  }

  function comprarEnShopify(pack) {
    var btn = $("hcpa-comprar");
    var txt = $("hcpa-comprar-txt");
    var err = $("hcpa-comprar-error");
    if (pack.disponible === false) { err.textContent = "Esta opción está agotada por ahora."; return; }
    var raizUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    txt.textContent = "Preparando tu pedido…";

    pedir(raizUrl + "cart.js")
      .then(function (carrito) {
        var viejos = carrito.items.filter(function (it) { return it.product_id === tienda.productoId; });
        return viejos.reduce(function (cadena, it) {
          return cadena.then(function () { return pedir(raizUrl + "cart/change.js", { id: it.key, quantity: 0 }); });
        }, Promise.resolve());
      })
      .then(function () {
        return pedir(raizUrl + "cart/add.js", { items: [{ id: pack.variante, quantity: pack.cantidadForm || 1 }] });
      })
      .then(function () { window.location.href = raizUrl + "checkout"; })
      .catch(function () {
        btn.removeAttribute("aria-busy");
        btn.disabled = false;
        txt.textContent = "Comprar ahora · " + pesos(pack.precio);
        err.textContent = "No pudimos agregar tu pedido. Revisa tu conexión e inténtalo de nuevo.";
      });
  }

  /* ---------- Galería con puntos ---------- */
  var pista = $("hcpa-galeria");
  var items = pista.children;
  var puntos = $("hcpa-puntos");
  Array.prototype.forEach.call(items, function () { puntos.appendChild(document.createElement("span")); });
  function fotoActual() { return Math.round(pista.scrollLeft / pista.clientWidth); }
  function pintarPuntos() {
    var n = fotoActual();
    Array.prototype.forEach.call(puntos.children, function (p, i) { p.classList.toggle("is-activo", i === n); });
  }
  pista.addEventListener("scroll", function () { window.requestAnimationFrame(pintarPuntos); }, { passive: true });
  raiz.querySelectorAll(".hcpa-galeria__flecha").forEach(function (b) {
    b.addEventListener("click", function () {
      var n = (fotoActual() + Number(b.getAttribute("data-dir")) + items.length) % items.length;
      pista.scrollTo({ left: n * pista.clientWidth, behavior: suave() });
    });
  });
  pintarPuntos();

  /* ---------- CTA fijo en celular ---------- */
  var sticky = $("hcpa-sticky");
  if ("IntersectionObserver" in window) {
    var visibles = new Set();
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) visibles.add(en.target); else visibles.delete(en.target);
      });
      sticky.classList.toggle("is-oculto", visibles.size > 0);
    });
    [$("hcpa-h1"), $("hcpa-zona-compra")].forEach(function (el) { io.observe(el); });
  } else {
    sticky.classList.remove("is-oculto");
  }

  /* ---------- Enlaces internos ---------- */
  // El navegador ignora un enlace #ancla si la URL ya termina en esa ancla; aquí se
  // desplaza siempre, toque el botón que toque.
  raiz.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented) return;
    var destino = document.getElementById(a.getAttribute("href").slice(1));
    if (!destino || !raiz.contains(destino)) return;
    e.preventDefault();
    destino.scrollIntoView({ block: destino.id === "hcpa-zona-compra" ? "center" : "start", behavior: suave() });
  });

  /* ---------- Arranque ---------- */
  pintarPacks();
  pintarPlanes();
  refrescar();
  if (tienda) conectarReleasit(20);
})();
